export const appConstants = {
  NOTIF_TITLE_SUCCESS: 'Berhasil',
  NOTIF_TITLE_ERROR: 'Gagal',
}
